import { ActionType } from '../../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { UserInfo } from '../../authState';


const KEY_ACTION = ActionType.LoginBXRequest;
const ACTIONS = [
  ActionType.LoginBXRequest,
  ActionType.LoginBXResponse,
  ActionType.LoginBXError,
];


type Payload = UserInfo;


type Meta = {
  email: string;
  projectId: string;
  logoutUrl: string;
};


/**
 * Dispatch this action to authenticate to the portal with user credentials
 * @param email - and encrypted string containg email address and time stamp
 * @param projectId - project id for report recipient
 * @param logoutUrl - redirect URL for logout
 */
export const loginBXAction = (
  email: string, projectId: string, logoutUrl: string) => makeApiAction<Payload, Meta>({
    method: 'POST',
    endpoint: Endpoints.AuthenticateBX,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email: email }),
    types: makeRsaaTypes<Payload, Meta>(ACTIONS, { email: email, projectId: projectId, logoutUrl: logoutUrl }),
    bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  const updatedUser = payload;
  updatedUser!.passwordUsed = updatedUser?.temporaryPasskey ?? ''; //TODO = pw handling for BX?

  const withLogoutUrl = R.assocPath([ 'auth', 'logoutUrl' ], action.meta.logoutUrl, successState);
  const withProjId = R.assocPath([ 'auth', 'defaultRecipientProjectId' ], action.meta.projectId, withLogoutUrl);
  return R.assocPath([ 'auth', 'currentUser' ], updatedUser, withProjId);
};

export const loginBXReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);